import { isValid } from 'date-fns';
import parseISO from 'date-fns/parseISO';
/** for use with JSON.parse.
 * If value is an ISO8601 datetime (ex: "2023-06-16T11:11:11.000Z") string - converts it to a Date */
export const isoDateParser = function (key: string, value: any): any {
  if (typeof value === 'string' && value.length >= 19) {
    const isoDateTime = parseISO(value);
    if (isValid(isoDateTime)) {
      return isoDateTime;
    }
  }
  return value;
};
